module.exports = __webpack_public_path__ + "officialStatic/img/new.9a4ebb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/new.png
// module id = jynK
// module chunks = 0